import { render, staticRenderFns } from "./addSegmentation.vue?vue&type=template&id=73d62113&"
import script from "./addSegmentation.vue?vue&type=script&lang=js&"
export * from "./addSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./addSegmentation.vue?vue&type=style&index=0&id=73d62113&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports